import { render, staticRenderFns } from "./contact2.vue?vue&type=template&id=5e037198&scoped=true&"
import script from "./contact2.vue?vue&type=script&lang=js&"
export * from "./contact2.vue?vue&type=script&lang=js&"
import style0 from "./contact2.vue?vue&type=style&index=0&id=5e037198&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e037198",
  null
  
)

export default component.exports